import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconMicOffComponent } from "./med-icon-mic-off.component";

@NgModule({
  declarations: [
    MedIconMicOffComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconMicOffComponent,
  ],
})
export class MedIconMicOffModule { }
